module.exports = __webpack_public_path__ + "img/building.97a3d012.svg";